import React from "react";

export default function TrophyUnlockModal({ trophy, onClose, regions }) {
  const regionData = regions.find((r) => r.code === trophy.region);

  if (!regionData) return null;

  const rewards = trophy.region_league_rewards;

  return (
    <div className="modal-overlay" onClick={onClose} style={{ zIndex: "1000" }}>
      <div
        className="modal-matchup"
        onClick={(e) => e.stopPropagation()}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "14px",
          padding: "0",
          //   background:
          //     `linear-gradient(200deg, rgba(${regionData.color2},1) 0%, rgba(${regionData.color},1) 100%)`,
          animation: "trophyPop 0.45s ease",
          maxHeight: "90vh",
          width: "720px",
        }}>
        <img
          src="/tournament-end-bg.png"
          style={{
            width: "100%",
            objectFit: "cover",
            height: "236px",
            objectPosition: "50% 20%",
            opacity: "0.4",
            WebkitMaskImage: "linear-gradient(to bottom, rgba(0,0,0,1) 20%, rgba(0,0,0,0) 100%)",
            maskImage: "linear-gradient(to bottom, rgba(0,0,0,1) 20%, rgba(0,0,0,0) 100%)",
          }}
          alt="Tournament Region Trophy Badge"
        />
        <img
          src="/rewards-banner.png"
          style={{
            width: "100%",
            objectPosition: "50% 20%",
            marginTop: "-170px",
            zIndex: 10,
          }}
           alt="Tournament Region Banner"
        />
        <h2
          style={{
            zIndex: "10",
            fontSize: "26px",
            textAlign: "center",
            textShadow: "rgb(0, 0, 0 / 42%) 1px 0 8px",
            lineHeight: "90%",
            margin: "0",
            maxWidth: "350px",
          }}>
          {trophy.region} Official Fantasy League
        </h2>
        <h2 style={{ color: "#3273fa", margin: 0 }}>Congratulations! </h2>
        <p style={{ color: "#fff", margin: 0 }}>
          You won the <b>{trophy.region}</b> league trophy!
        </p>
        <p style={{ color: "#fff", margin: 0 , textAlign: "center"}}>Equip your new trophy badge in the profile page</p>
        <div className="reward-grid">
          <div className="reward-card">
            <img src="/sunshine-ray.png" className="reward-rays"  alt="Background Sun Rays Reward"/>
            <img src={regionData.trophyUnlocked} className="reward-icon"  alt="Tournament Region Trophy Badge"/>
          </div>
          {rewards.coins > 0 && (
            <div className="reward-card">
              <img src="/sunshine-ray.png" className="reward-rays"  alt="Background Sun Rays Reward"/>
              <img src="/many-tokens.png" className="reward-icon"  alt="Tournament Region Trophy Tokens"/>
              <div className="reward-value">{rewards.coins}</div>
            </div>
          )}
          {rewards.xp > 0 && (
            <div className="reward-card">
              <img src="/sunshine-ray.png" className="reward-rays"  alt="Background Sun Rays Reward"/>
              <div className="reward-xp">XP</div>
            </div>
          )}
          {rewards.xp_boost > 0 && (
            <div className="reward-card">
              <img src="/sunshine-ray.png" className="reward-rays"  alt="Background Sun Rays Reward"/>
              <img src="/mini-boosts.png" className="reward-icon"  alt="Tournament Region Trophy Practice Boost"/>
              <div className="reward-value">+{rewards.xp_boost}</div>
            </div>
          )}
          {rewards.grants_international_ticket && (
            <div className="reward-card">
              <img src="/sunshine-ray.png" className="reward-rays" alt="Background Sun Rays Reward"/>
              <img src={rewards.ticket_image} className="reward-icon" alt="Tournament Region Trophy International Ticket"/>
            </div>
          )}
        </div>
        <button className="edit-btn" onClick={onClose} style={{ marginBottom: "20px" }}>
          Claim
        </button>
      </div>
    </div>
  );
}
